module.exports = __webpack_public_path__ + "img/selected2-min.4d05c615.png";